import { paymanService } from "@/common/api.service"
import { paymanStatus } from "@/constants/paymanStatus"

const initialStates = {
    status: 'loading',
    paymans: [],
    form_data: {
        farsi_name: '',
        english_name: '',
        website_address: '',
        callback_address: '',
        server_ip: '',
    }
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, paymans) {
        state.status  = 'success'
        state.paymans = paymans
    },
    fail(state) {
        state.status  = 'fail'
        state.paymans = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key){
            if(key == 'sheba') {
                state.form_data[key] = []
            }else {
                state.form_data[key] = ''
            }
        });
    }
}

const getters = {
    status: ({status}) => status,
    paymans: ({paymans}) => paymans,
    form_data: ({form_data}) => form_data,
    active_paymans: ({paymans}) => {
        if(paymans.data) {
            return paymans.data.filter(payman =>
                payman.status === paymanStatus.ACTIVE
            )
        }

        return paymans.filter(payman =>
            payman.status === paymanStatus.ACTIVE
        )
    }
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return paymanService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    fetchByUserId({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id
        }
        return paymanService.fetch(params).then(response => {
            commit('success', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        
        return paymanService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}